export const W = 'U2V1IGhpa2VyIGhhY2tlciE=';
export const EVENT_DURATION = 30;
